/**
 *
 * ComplimentBadge
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import CheckCircleIcon from '../../../../assets/v2/CheckCircleIcon';
import { COLORS } from '../../../../theme';
import Badge from '..';

const StyledBadge = styled(Badge)`
  &.MuiChip-root {
    color: ${COLORS.greenDark};
    background: ${COLORS.greenLight};
    border-color: ${COLORS.green};
  }

  && .MuiSvgIcon-root {
    path {
      fill: ${COLORS.green};
    }
  }
`;

function ComplimentBadge(props) {
  return (
    <StyledBadge
      icon={<CheckCircleIcon />}
      size="iconLarge"
      variant="outlined"
      {...props}
    />
  );
}

export default memo(ComplimentBadge);
